/* eslint-disable */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

function _typeof(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

import React from 'react';

import * as _propTypes from 'prop-types';

import _classnames2 from 'classnames';

import * as _theme from '@veneer/theme';

import * as _reactMergeRefs from 'react-merge-refs';

import * as _styles from './styles';

import * as _use_focus_visible from '../utils/use_focus_visible';

import * as _use_controlled from '../utils/use_controlled';

import * as _use_direction from '../direction/use_direction';

import * as _utils from './utils';

import * as _core from '@emotion/react';

var _excluded = [
  'aria-label',
  'className',
  'defaultValue',
  'disabled',
  'maxValue',
  'minValue',
  'name',
  'onChange',
  'step',
  'theme',
  'value',
  'tooltip',
  'orientation',
  'isRTL'
];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(
    nodeInterop
  ) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (
    obj === null ||
    (_typeof(obj) !== 'object' && typeof obj !== 'function')
  ) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) ||
        arr['@@iterator'];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var Slider = /*#__PURE__*/ React.forwardRef(function (props, ref) {
  var _classnames;

  var ariaLabel = props['aria-label'],
    className = props.className,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    maxValue = props.maxValue,
    minValue = props.minValue,
    name = props.name,
    onChange = props.onChange,
    step = props.step,
    theme = props.theme,
    valueProp = props.value,
    tooltip = props.tooltip,
    orientation = props.orientation,
    isRTL = props.isRTL,
    thumbProps = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    movementStarted = _React$useState2[0],
    setMovementStarted = _React$useState2[1];

  var sliderContainer = React.useRef(undefined);
  var sliderThumb = React.useRef(undefined);

  const tooltipRef = React.useRef(null);
  const [tooltipWidth, setTooltipWidth] = React.useState(0);

  React.useEffect(() => {
    if (tooltipRef.current) {
      setTooltipWidth(tooltipRef.current.offsetWidth);
    }
  }, [value, tooltip, movementStarted]);

  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focusVisible = _React$useState4[0],
    setFocusVisible = _React$useState4[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useFocusVisible = (0, _use_focus_visible.default)(),
    handleBlurVisible = _useFocusVisible.handleBlurVisible,
    handleFocusVisible = _useFocusVisible.handleFocusVisible,
    focusVisibleRef = _useFocusVisible.ref;

  var _useControlled = (0, _use_controlled.default)({
      controlled: valueProp,
      default: defaultValue
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];

  var isVertical = orientation === 'vertical';

  var _useDirection = (0, _use_direction.default)(),
    rtl = _useDirection.isRTL;

  var isRTL = props.isRTL && !isVertical;
  React.useImperativeHandle(ref, function () {
    return {
      blur: function blur() {
        if (sliderThumb.current) {
          sliderThumb.current.blur();
        }
      },
      focus: function focus() {
        if (sliderThumb.current) {
          sliderThumb.current.focus();
        }
      },
      node: sliderContainer,
      thumb: sliderThumb,
      value: value
    };
  });

  var moveSlider = function moveSlider(newValue, event) {
    var clampedValue = newValue;

    if (newValue > maxValue) {
      clampedValue = maxValue;
    } else if (newValue < minValue) {
      clampedValue = minValue;
    }

    if (clampedValue !== value) {
      setValue(clampedValue);
      if (onChange) onChange(clampedValue);
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  var focusThumb = function focusThumb() {
    if (sliderThumb.current) sliderThumb.current.focus();
  };

  var handleClick = function handleClick(event, eventType) {
    if (disabled || !sliderContainer) return;
    event.preventDefault();
    var clientX =
      event.type !== 'touchmove'
        ? event.clientX
        : event.changedTouches[0].clientX;
    var clientY =
      event.type !== 'touchmove'
        ? event.clientY
        : event.changedTouches[0].clientY;
    var percentValue = (0, _utils.getPercentByClientDisplacement)({
      client: isVertical ? clientY : clientX,
      eventType: eventType,
      sliderContainer: sliderContainer,
      isVertical: isVertical
    });
    var newValue = isRTL
      ? Math.ceil((0, _utils.percentToValue)(percentValue, minValue, maxValue))
      : Math.ceil((0, _utils.percentToValue)(percentValue, maxValue, minValue));
    moveSlider(newValue, event);
    focusThumb();
  };

  var handleWheel = function handleWheel(event) {
    if (disabled) return;
    var newValue = event.deltaY > 0 ? value - 2 : value + 2;
    moveSlider(newValue);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (disabled) return;
    setMovementStarted(true);
    var stepValue = step || (maxValue - minValue) / 10;
    var newValue;

    switch (event.keyCode) {
      case _utils.keyCode.left:
      case _utils.keyCode.down:
        newValue = value - 1;
        break;

      case _utils.keyCode.right:
      case _utils.keyCode.up:
        newValue = value + 1;
        break;

      case _utils.keyCode.pageDown:
        newValue = value - stepValue;
        break;

      case _utils.keyCode.pageUp:
        newValue = value + stepValue;
        break;

      case _utils.keyCode.home:
        newValue = minValue;
        break;

      case _utils.keyCode.end:
        newValue = maxValue;
        break;

      default:
        break;
    }

    if (newValue != null) moveSlider(newValue, event);
  };

  var handleKeyUp = function handleKeyUp() {
    if (disabled) return;
    setMovementStarted(false);
  };

  var handleMovementStop = function handleMovementStop(event) {
    if (disabled) return;
    setMovementStarted(false);

    switch (event.type) {
      case 'mouseup':
        document.removeEventListener('mousemove', handleClick);
        document.removeEventListener('mouseup', handleMovementStop);
        event.preventDefault();
        break;

      case 'touchend':
        document.removeEventListener('touchmove', handleClick);
        document.removeEventListener('touchend', handleMovementStop);
        event.preventDefault();
        break;

      default:
        break;
    }
  };

  var handleMovementStart = function handleMovementStart(event) {
    if (disabled) return;
    setMovementStarted(true);

    switch (event.type) {
      case 'mousedown':
        document.addEventListener('mousemove', handleClick);
        document.addEventListener('mouseup', handleMovementStop);
        break;

      case 'touchstart':
        document.addEventListener('touchmove', handleClick, {
          passive: false
        });
        document.addEventListener('touchend', handleMovementStop);
        break;

      default:
        break;
    }
  };

  var handleBlur = function handleBlur(event) {
    var onBlur = thumbProps.onBlur;

    if (focusVisible) {
      setFocusVisible(false);
      handleBlurVisible(event);
    }

    if (onBlur) onBlur(event);
  };

  var handleFocus = function handleFocus(event) {
    var onFocus = thumbProps.onFocus;

    if (handleFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) onFocus(event);
  };

  var handleRef = (0, _reactMergeRefs.default)([sliderThumb, focusVisibleRef]);
  var trackWidth = (0, _utils.valueToPercent)(value, maxValue, minValue);
  return (0, _core.jsx)(
    'div',
    {
      css: (0, _styles.default)({
        disabled: disabled,
        focusVisible: focusVisible,
        movementStarted: movementStarted,
        theme: theme,
        trackWidth: trackWidth,
        isVertical: isVertical,
        tooltipWidth: tooltipWidth,
        isRTL: isRTL
      })
    },
    (0, _core.jsx)(
      'div',
      {
        className: 'side',
        onClick: function onClick(e) {
          return handleClick(e, _utils.MINIMUM_EVENT_CLICK);
        }
      },
      (0, _core.jsx)('span', {
        className: 'side--minimum'
      })
    ),
    (0, _core.jsx)(
      'div',
      {
        className: (0, _classnames2.default)(
          ((_classnames = {}),
          _defineProperty(_classnames, className, className),
          _defineProperty(_classnames, 'bar', true),
          _classnames)
        ),
        onClick: handleClick,
        onWheel: handleWheel,
        ref: sliderContainer
      },
      (0, _core.jsx)('div', {
        className: 'rail'
      }),
      (0, _core.jsx)('div', {
        className: 'track'
      }),
      (0, _core.jsx)('input', {
        name: name,
        type: 'hidden',
        value: value
      }),
      (0, _core.jsx)(
        'div',
        _extends({}, thumbProps, {
          'aria-disabled': disabled,
          'aria-label': ariaLabel,
          'aria-valuemax': maxValue,
          'aria-valuemin': minValue,
          'aria-valuenow': value,
          className: 'thumb',
          onBlur: handleBlur,
          onClick: function onClick(event) {
            return event.stopPropagation();
          },
          onFocus: handleFocus,
          onKeyDown: handleKeyDown,
          onMouseDown: handleMovementStart,
          onTouchStart: handleMovementStart,
          onKeyUp: handleKeyUp,
          ref: handleRef,
          role: 'slider',
          tabIndex: disabled ? null : 0
        })
      )
    ),
    (0, _core.jsx)(
      'div',
      {
        className: 'side',
        onClick: function onClick(e) {
          return handleClick(e, _utils.MAXIMUM_EVENT_CLICK);
        }
      },
      (0, _core.jsx)('span', {
        className: 'side--maximum'
      })
    ),
    tooltip &&
      movementStarted &&
      (0, _core.jsx)(
        'div',
        {
          ref: tooltipRef,
          className: 'tooltip caption-large'
        },
        (0, _core.jsx)('span', {}, value === undefined ? '' : value)
      )
  );
});
Slider.propTypes = {
  'aria-label': _propTypes.default.string,
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  maxValue: _propTypes.default.number,
  minValue: _propTypes.default.number,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  step: _propTypes.default.number,
  theme: _propTypes.default.shape({}).isRequired,
  value: _propTypes.default.number,
  tooltip: _propTypes.default.bool,
  orientation: _propTypes.default.oneOf(['vertical', 'horizontal']),
  isRTL: _propTypes.default.bool
};
Slider.defaultProps = {
  'aria-label': undefined,
  className: undefined,
  defaultValue: 0,
  disabled: false,
  maxValue: 100,
  minValue: 0,
  name: undefined,
  onChange: function onChange() {},
  step: undefined,
  value: undefined,
  tooltip: false,
  orientation: 'horizontal',
  isRTL: false
};
Slider.displayName = 'Slider';

var _default = (0, _theme.withTheme)(Slider);

export default _default;
